import { useProductCardContext } from 'palette/ProductCard';
import { Header } from 'palette/Typography';

import './styles/ComingSoonSplash.scss';

interface ComingSoonSplashProps {
    size: string;
}

export function ComingSoonSplash({ size }: ComingSoonSplashProps) {
    const { cardLabels } = useProductCardContext();
    return (
        <div className="coming-soon-splash">
            <Header
                className="coming-soon-splash__label"
                color="strong"
                level={size === 'small' ? '4' : '2'}
                transform="uppercase"
            >
                {cardLabels.comingSoon}
            </Header>
        </div>
    );
}
